import React from 'react';
import { Link } from 'react-router-dom';
import Footer from './Footer.js';

const NotFound = () => {
  return (
    <div>
      <div className="league-content">
        <div className="league-body" style={{ textAlign: 'center', paddingTop: '4rem', paddingBottom: '4rem' }}>
          <p className="league-title-standard-secondary">This page doesn't exist.</p>
          <Link to="/" className="btn btn-dark">Take me back to the homepage</Link>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default NotFound;
